import React, {useEffect, useState} from 'react';
import {io} from 'socket.io-client';

const socket = io('ws://127.0.0.1:8086/ws', {
    transports: ["websocket"],
    withCredentials: true
});

interface ChatRoomProps {
    roomId: string;
}

const ChatRoom = ({roomId}: ChatRoomProps) => {
    const [room, setRoom] = useState<string>('general');
    const [message, setMessage] = useState<string>('');
    const [messages, setMessages] = useState<string[]>([]);

    useEffect(() => {
        socket.on('message', (msg: string) => {
            setMessages((prevMessages) => [...prevMessages, msg]);
        });

        return () => {
            socket.off('message');
        };
    }, []);

    // Dołączanie do pokoju
    const joinRoom = (newRoom: string) => {
        setRoom(newRoom);
        socket.emit('message', `join:${newRoom}`);
        setMessages([]); // Czyścimy wiadomości po zmianie pokoju
    };

    // Wysyłanie wiadomości
    const sendMessage = () => {
        if (message.trim() !== '') {
            socket.emit('message', `message:${room}:${message}`);
            setMessage('');
        }
    };

    return (
        <div>
            <h1>Chat Room</h1>
            <div>
                <button onClick={() => joinRoom(roomId)}>roomId</button>
                <button onClick={() => joinRoom('tech')}>Tech</button>
                <button onClick={() => joinRoom('random')}>Random</button>
            </div>
            <div>
                <h2>Room: {room}</h2>
                <div>
                    {messages.map((msg, index) => (
                        <p key={index}>{msg}</p>
                    ))}
                </div>
                <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Type a message..."
                />
                <button onClick={sendMessage}>Send</button>
            </div>
        </div>
    );
};

export default ChatRoom;